import { Layout, NoMatch } from "./layout";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";
import { EnvironmentPolicyPage } from "./pages/EnvironmentPolicyPage";
import { HSEPolicyPage } from "./pages/HSEPolicyPage";
import { HomePage } from "./pages/HomePage";
import { ProjectsPage } from "./pages/ProjectsPage";
import { QualityPolicyPage } from "./pages/QualityPolicyPage";

export const routes = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "about", element: <AboutPage /> },
      { path: "contact", element: <ContactPage /> },
      { path: "projects", element: <ProjectsPage /> },
      { path: "environment-policy", element: <EnvironmentPolicyPage /> },
      { path: "hse-policy", element: <HSEPolicyPage /> },
      { path: "quality-policy", element: <QualityPolicyPage /> },
      { path: "*", element: <NoMatch /> },
    ],
  },
];

export const routePaths = [
  "/",
  "/about",
  "/contact",
  "/projects",
  "/environment-policy",
  "/hse-policy",
  "/quality-policy",
];
